import { Component } from '@angular/core';
import { App } from 'ionic-angular';

/**
 * Account Page
 * 
 * @export
 * @class AccountPage
 * @extends {AccountLoginPage}
 */
@Component({
    selector: 'account-page',
    templateUrl: 'account.html'
})
export class AccountPage {
    constructor(
        public app: App
    ) { }

    ionViewDidEnter() {
        this.app.setTitle('Account');
    }
}


// WEBPACK FOOTER //
// ./src/pages/account/account.ts